import React, { useCallback } from 'react'

import { SvgImage } from 'components/SvgImage'

import { useABTest } from 'hooks/useABTest'
import { useActiveCohortIdentifier } from 'hooks/useActiveCohortIdentifier'
import { useGetPageInfo } from 'hooks/useGetPageInfo'
import { useOnboardingProgressStepsLength } from 'hooks/useOnboardingProgressStepsLength'

import arrowBlackSvg from 'assets/images/sprite/arrow-back-black.svg'
import arrowSvg from 'assets/images/sprite/arrow-back-gray.svg'
import logoSvg from 'assets/images/sprite/logo.svg'

import { goBack } from 'browser-history'

import { StyledHeaderMinimalistic as S } from './HeaderMinimalistic.styles'

// use this header for MINIMALISTIC_HEADER_COHORTS-list
export const HeaderMinimalistic: React.FC = () => {
  const {
    progressValue,
    hasNavigation,
    hasProgressBar,
    hasMinimalisticHeader,
  } = useGetPageInfo()
  const { isCoralThemeCohort, isLuvlyIntroFastCohort, isLuvlyWellhubCohort } =
    useActiveCohortIdentifier()
  const progressStepsLength = useOnboardingProgressStepsLength()
  const { isIntroFastCoralThemeActive } = useABTest()

  const handleBack = useCallback(() => {
    goBack()
  }, [])

  const coralThemeStyles =
    (isLuvlyIntroFastCohort && isIntroFastCoralThemeActive) ||
    isCoralThemeCohort ||
    isLuvlyWellhubCohort

  return (
    <S.Wrapper
      hasNavigation={hasNavigation}
      hasProgressBar={hasProgressBar}
      hasShadow={!hasMinimalisticHeader}
      applyCoralTheme={coralThemeStyles}
    >
      <S.ArrowIconContainer isVisible={hasNavigation}>
        <SvgImage
          svg={coralThemeStyles ? arrowBlackSvg : arrowSvg}
          width={24}
          height={24}
          cursor="pointer"
          onClick={handleBack}
        />
      </S.ArrowIconContainer>
      <SvgImage svg={logoSvg} width={58} height={24} />
      <S.PageNumberContainer
        isVisible={hasNavigation}
        applyCoralTheme={coralThemeStyles}
      >
        <span>{progressValue}</span>
        <span>/</span>
        <span>{progressStepsLength}</span>
      </S.PageNumberContainer>
    </S.Wrapper>
  )
}
